export default [
  {
    sceneConfig: {
      triggerElement: '.cosmos-svg',
      triggerHook: 'onEnter',
      duration: '150%',
    },
    tweenConfig: {
      type: 'move',
      className: 'cosmos-svg__image',
      direction: 'up',
      distance: '40'
    }
  }
];



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/scroll-data.js